<!-- <div class="modal-header">
    <h5 class="modal-title">Available Coupons</h5>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div> -->
  
<div class="coupon-box-wrapper" style="max-width: 100%;">
  <div *ngIf="appliedCoupon" class="d-flex align-items-center justify-content-between coupon-box">
    <div class="d-flex align-items-center">
      <i class="bi bi-ticket-perforated-fill fs-4 me-2"></i>
      <span class="fw-boldest">{{ couponCode }}</span>
    </div>
    <button class="btn btn-link text-danger p-1 fw-boldest" (click)="onRemove()">
      Remove
    </button>
  </div>

  <div *ngIf="appliedCoupon" class="text-success mt-2">
    The discount coupon has been applied
  </div>

  <div *ngIf="!appliedCoupon" class="d-flex align-items-center justify-content-between coupon-box mt-3">
    <div class="d-flex align-items-center w-100 me-3">
      <i class="bi bi-ticket-perforated-fill fs-5 me-2"></i>
     <input type="text"class="form-control bg-transparent border-0 shadow-none py-1 px-2" style="font-style: italic;"
  placeholder="Discount code"
  [(ngModel)]="couponCode" />
    </div>
    <button class="btn btn-link text-primary p-1 fw-boldest" (click)="applyCouponCode()">
      Apply
    </button>
  </div>
</div>

<!-- 
    <ul class="list-group">
      <li *ngFor="let coupon of coupons" class="list-group-item d-flex justify-content-between align-items-center">
        <div>
          <strong>{{ coupon.name }}</strong> – 
          <span *ngIf="coupon.type === 'amount'">${{ coupon.value }} OFF</span>
          <span *ngIf="coupon.type === 'percentage'">{{ coupon.value }}% OFF</span>
        </div>
        <button 
          class="btn btn-sm btn-success" 
          (click)="applyCoupon(coupon)" 
          [disabled]="appliedCoupon?.name === coupon.name">
          {{ appliedCoupon?.name === coupon.name ? 'Applied' : 'Apply' }}
        </button>
      </li>
    </ul> -->
  <!-- </div> -->
  